import { render, staticRenderFns } from "./DynamicNei.vue?vue&type=template&id=6a6f5f1c&scoped=true"
import script from "./DynamicNei.vue?vue&type=script&lang=js"
export * from "./DynamicNei.vue?vue&type=script&lang=js"
import style0 from "./DynamicNei.vue?vue&type=style&index=0&id=6a6f5f1c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6f5f1c",
  null
  
)

export default component.exports